import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Add a new payment request
export const addPaymentRequest = async (requestData) => {
  try {
    const response = await axios.post(`${API_URL}/payment-requests`, requestData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get all payment requests
export const getAllPaymentRequests = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/payment-requests`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Vendor-Wise summary — one row per vendor with Approved/Pending counts +
// value totals, paginated + searchable server-side (must be called before
// getPaymentRequestById in routing terms, but that's a backend concern only).
export const getVendorPaymentSummary = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/payment-requests/vendor-summary`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Project-Wise summary — same idea as getVendorPaymentSummary above, grouped
// by client ("Project") instead of vendor.
export const getProjectPaymentSummary = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/payment-requests/project-summary`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get single payment request by ID
export const getPaymentRequestById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/payment-requests/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update payment request status
export const updatePaymentRequestStatus = async (id, statusData) => {
  try {
    const response = await axios.put(`${API_URL}/payment-requests/${id}/status`, statusData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update payment request
export const updatePaymentRequest = async (id, requestData) => {
  try {
    const response = await axios.put(`${API_URL}/payment-requests/${id}`, requestData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete payment request
export const deletePaymentRequest = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/payment-requests/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Upload one or more receipt images for a payment request
export const uploadPaymentRequestImages = async (id, files) => {
  try {
    const formData = new FormData();
    files.forEach((file) => formData.append('images', file));
    const response = await axios.post(`${API_URL}/payment-requests/${id}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete a single receipt image from a payment request
export const deletePaymentRequestImage = async (id, key) => {
  try {
    const response = await axios.delete(`${API_URL}/payment-requests/${id}/images`, { data: { key } });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
